import React from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames';
import Item from './cluster-item';
import ConfigProvider from '../../config-provider';
import Icon from '../../icon';
import { obj } from '../../util';

// 头像群
class ClusterAvatar extends React.Component {
  static propTypes = {
    prefix: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    dataSource: PropTypes.arrayOf(PropTypes.shape({
      img: PropTypes.string,
      text: PropTypes.string.isRequired,
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })),
    colorSets: PropTypes.arrayOf(PropTypes.string),
    onSelect: PropTypes.func,
    onClose: PropTypes.func,
    onAdd: PropTypes.func,
  }

  static defaultProps = {
    prefix: 'next-',
    dataSource: [],
    colorSets: ['#BC61CF', '#F26666', '#F29A52', '#F4C329', '#CBD057', '#289ED3', '#29B3F0'],
    onSelect: () => {},
    onClose: () => {},
    onAdd: () => {},
  }

  render() {
    const {
      prefix,
      dataSource,
      colorSets,
      style,
      className,
      onSelect,
      onClose,
      onAdd,
      ...others
    } = this.props;
    return (
      <div
        style={style}
        className={cls({
          [`${prefix}avatar-cluster`]: true,
          [className]: !!className,
        })}
        {...obj.pickAttrs(others)}
      >
        {
          dataSource.map(d => <Item key={d.id} data={d} colorSets={colorSets} onClick={onSelect} onClose={onClose} />)
        }
        <Icon
          type="plus-o-fill"
          size="xl"
          className={`${prefix}avatar-cluster-add`}
          onClick={onAdd}
        />
      </div>
    );
  }
}

export default ConfigProvider.config(ClusterAvatar);
